import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { GeneralSmartParkError } from 'src/types';

const RESOURCE = '/cash-collection/cash-collection/:id/';

interface DTO {
    id: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ id }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { id }));
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteCashCollection };
export type { DTO as DeleteCashCollectionDTO };
